import { SidebarIcon, type SidebarIconProps } from "./sidebar-icon";

export const SidebarClosedIcon = (props: SidebarIconProps) => (
  <SidebarIcon side="left" open={false} {...props} />
);
